import { render } from "./StatCard.vue?vue&type=template&id=21ce35e1&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=js"
export * from "./StatCard.vue?vue&type=script&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=21ce35e1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ce35e1"]])

export default __exports__